import getSidebarItems from './other';

const userData = JSON.parse(localStorage.getItem('userData'));
const role = userData?.role || 'default';

const menuItems = {
    items: [getSidebarItems(role)]
};

export default menuItems;
